import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { ErrorMessageService } from '@core/service/error-message.service';
import { AuthService } from '@core/service/auth.service';
import { IntegerFormatPipe } from '../../../core/pipe/integer-format.pipe';

@Component({
  selector: 'app-modal-etat-des-lieux',
  imports: [CommonModule, FormsModule, IntegerFormatPipe],
  templateUrl: './modal-etat-des-lieux.component.html',
  styleUrl: './modal-etat-des-lieux.component.scss',
})
export class ModalEtatDesLieuxComponent {
  action: string = 'add';
  dialogTitle: string = '';
  itemToSave: any = {};
  itemsEtatDesLieux: any = [];
  itemsDetailEtatDesLieux: any = [];
  isLoading: boolean = false;
  user: any;
  loading: boolean | undefined;
  imageDisplay: any;
  imageName: string | undefined;
  currentItemImage:
    | {
        fileBase64: any;
        fileName: any;
        extension: any;
        typeDocument: string;
      }
    | undefined;
  endPoint: string = 'etatDesLieux';
  title = 'etat des lieux';
  createMessage = '';
  editMessage = '';
  deleteMessage = '';
  gender = 'M';
  itemsEtatDesLieuxDetail: any = [];
  itemsChambreCommodite: any;
  itemEtatDesLieux: any = {};

  get isCheckIn(): boolean {
    return !this.itemEtatDesLieux?.id;
  }

  get isSortieFaite(): boolean {
    if (!this.itemsEtatDesLieuxDetail?.length) return false;
    return this.itemsEtatDesLieuxDetail.some(
      (item: any) => item.updated_by || item.updated_at
    );
  }

  constructor(
    public activeModal: NgbActiveModal,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private errorMessage: ErrorMessageService,
    private authService: AuthService
  ) {
    this.user = this.authService.getCurrentUser();
    const text1 = this.gender == 'M' ? 'un' : 'une';
    this.createMessage =
      'Vous êtes sur le point de créer ' + text1 + ' ' + this.title;
    this.editMessage =
      'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title;
    this.deleteMessage =
      'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title;
  }

  ngOnInit() {
    this.getItemsEtatDesLieux();
  }

  submit() {}

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.imageName = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }
  confirmSaveItem(item: any) {
    if (!item.id) item.code = this.generateUniqueString();
    let objToSave = Object.assign({}, item);
    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        if (this.itemEtatDesLieux.id) {
          this.updateDetail();
        } else {
          this.saveItem(objToSave);
        }
      }
    });
  }

  getItemsEtatDesLieux() {
    let request = {
      data: {
        hebergement_id: this.itemToSave.id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('etatDesLieux/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError'] && res['items'].length) {
          // Etat des lieux existant → sortie client : charger le détail existant
          this.itemEtatDesLieux = res['items'][0];
          this.getItemsEtatDesLieuxDetail(this.itemEtatDesLieux.id);
        } else {
          // Pas d'état des lieux → création : charger les commodités de la chambre
          this.itemEtatDesLieux = {
            libelle: this.composeLibelle(),
            chambre_id: this.itemToSave.chambre_id,
            hebergement_id: this.itemToSave.id,
            espace_id: this.itemToSave.espace_id,
            client_id: this.itemToSave.client_id,
          };
          this.getItemsChambreCommodite();
        }
      },
      (err) => {
        this.itemEtatDesLieux = {
          libelle: this.composeLibelle(),
          chambre_id: this.itemToSave.chambre_id,
          hebergement_id: this.itemToSave.id,
          espace_id: this.itemToSave.espace_id,
          client_id: this.itemToSave.client_id,
        };
        this.getItemsChambreCommodite();
      }
    );
  }

  getItemsEtatDesLieuxDetail(id: any) {
    let request = {
      data: {
        etat_des_lieux_id: id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('etatDesLieuxDetail/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsEtatDesLieuxDetail = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsEtatDesLieuxDetail = [];
        }
      },
      (err) => {
        this.itemsEtatDesLieuxDetail = [];
      }
    );
  }
  getItemsChambreCommodite() {
    let request = {
      data: {
        hotel_id: this.itemToSave.hotel_id,
        chambre_id: this.itemToSave.chambre_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('chambreCommodite/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsChambreCommodite = res['items'];
          this.itemsEtatDesLieuxDetail = [...this.itemsChambreCommodite];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsChambreCommodite = [];
        }
      },
      (err) => {
        this.itemsChambreCommodite = [];
      }
    );
  }

  saveItem(item: any) {
    console.info('item to save', item);

    this.isLoading = true;

    let itemAEnregistrer = Object.assign({}, item);
    itemAEnregistrer.itemsEtatDesLieuxDetail = this.itemsEtatDesLieuxDetail;

    var request = {
      datas: [itemAEnregistrer],
    };

    this.restClient.post(this.endPoint + '/create', request).subscribe(
      (res: any) => {
        console.info('resul', res);
        this.isLoading = false;

        if (!res['hasError']) {
          this.utilities.showNotification(
            'snackbar-success',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          // this.currentPage = 0
          this.activeModal.close();
        } else {
          if (res['status'] && res['status']['message']) {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
          }
        }
      },
      (err) => {
        this.utilities.showNotification(
          'snackbar-danger',
          this.utilities.getMessageEndPointNotAvailble(),
          'bottom',
          'center'
        );
        this.loading = false;
      }
    );
  }
  updateDetail() {
    this.isLoading = true;

    var request = {
      datas: this.itemsEtatDesLieuxDetail,
    };

    this.restClient.post('etatDesLieuxDetail/update', request).subscribe(
      (res: any) => {
        console.info('resul', res);
        this.isLoading = false;

        if (!res['hasError']) {
          this.utilities.showNotification(
            'snackbar-success',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          // this.currentPage = 0
          this.activeModal.close();
        } else {
          if (res['status'] && res['status']['message']) {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
          }
        }
      },
      (err) => {
        this.utilities.showNotification(
          'snackbar-danger',
          this.utilities.getMessageEndPointNotAvailble(),
          'bottom',
          'center'
        );
        this.loading = false;
      }
    );
  }
  getItems() {
    throw new Error('Method not implemented.');
  }

  generateUniqueString() {
    var timestamp = new Date().getTime();
    var randomNumber = Math.floor(Math.random() * 1000000);

    var uniqueString = timestamp.toString() + randomNumber.toString();
    return uniqueString;
  }
  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  calculerPrejudice(item: any) {
    const qte = parseFloat(item.quantite_defectueux) || 0;
    const valeur = parseFloat(item.valeur_approximative) || 0;
    item.montant_contentieux = qte * valeur;
  }

  composeLibelle(): string {
    const date = this.itemToSave.date_debut
      ? new Date(this.itemToSave.date_debut)
      : new Date();
    const dateStr = date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    const heureStr = date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    });
    const chambre =
      this.itemToSave.chambre_libelle || this.itemToSave.espace_libelle || '';
    return `Etat des lieux du ${dateStr} chambre ${chambre} heure ${heureStr}`;
  }

  addDocument(event: any) {
    console.log('event: ', event);
    // this.itemsImage = [...event];
  }
}
